import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_bb5c32c0 from 'nuxt_plugin_plugin_bb5c32c0' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_middleware_de133f60 from 'nuxt_plugin_middleware_de133f60' // Source: ./middleware.js (mode: 'all')
import nuxt_plugin_appplugin_cef3b808 from 'nuxt_plugin_appplugin_cef3b808' // Source: ../node_modules/@nuxt/bridge/dist/runtime/app.plugin.mjs (mode: 'all')
import nuxt_plugin_configplugin_6b82abda from 'nuxt_plugin_configplugin_6b82abda' // Source: ../node_modules/@nuxt/bridge/dist/runtime/config.plugin.mjs (mode: 'all')
import nuxt_plugin_nitrobridgeserver_7ffc0444 from 'nuxt_plugin_nitrobridgeserver_7ffc0444' // Source: ./nitro-bridge.server.mjs (mode: 'server')
import nuxt_plugin_nitrobridgeclient_2e8744cc from 'nuxt_plugin_nitrobridgeclient_2e8744cc' // Source: ./nitro-bridge.client.mjs (mode: 'client')
import nuxt_plugin_plugin_01c06582 from 'nuxt_plugin_plugin_01c06582' // Source: ../node_modules/@pinia/nuxt/dist/runtime/plugin.vue2 (mode: 'all')
import nuxt_plugin_image_ffb0029e from 'nuxt_plugin_image_ffb0029e' // Source: ./image.js (mode: 'all')
import nuxt_plugin_unhead_64b1d903 from 'nuxt_plugin_unhead_64b1d903' // Source: ../node_modules/@nuxt/bridge/dist/runtime/head/plugins/unhead (mode: 'all')
import nuxt_plugin_capiplugin_3a7f51c6 from 'nuxt_plugin_capiplugin_3a7f51c6' // Source: ./capi.plugin.mjs (mode: 'all')
import nuxt_plugin_errorpluginserver_0e3e162c from 'nuxt_plugin_errorpluginserver_0e3e162c' // Source: ../node_modules/@nuxt/bridge/dist/runtime/error.plugin.server.mjs (mode: 'server')
import nuxt_plugin_00loggerclient_2112379c from 'nuxt_plugin_00loggerclient_2112379c' // Source: ../plugins/00.logger.client.ts (mode: 'client')
import nuxt_plugin_00loggerserver_f268adb8 from 'nuxt_plugin_00loggerserver_f268adb8' // Source: ../plugins/00.logger.server.ts (mode: 'server')
import nuxt_plugin_01sentryclient_4e0d254a from 'nuxt_plugin_01sentryclient_4e0d254a' // Source: ../plugins/01.sentry.client.ts (mode: 'client')
import nuxt_plugin_02shopbackendclient_0abae047 from 'nuxt_plugin_02shopbackendclient_0abae047' // Source: ../plugins/02.shop-backend.client.ts (mode: 'client')
import nuxt_plugin_03fetchRedirectsserver_579ebf2e from 'nuxt_plugin_03fetchRedirectsserver_579ebf2e' // Source: ../plugins/03.fetchRedirects.server.ts (mode: 'server')
import nuxt_plugin_goliathclient_cffddb24 from 'nuxt_plugin_goliathclient_cffddb24' // Source: ../plugins/goliath.client.ts (mode: 'client')
import nuxt_plugin_goliathserver_048af814 from 'nuxt_plugin_goliathserver_048af814' // Source: ../plugins/goliath.server.ts (mode: 'server')
import nuxt_plugin_storeinitserver_12d7c08e from 'nuxt_plugin_storeinitserver_12d7c08e' // Source: ../plugins/store-init.server.ts (mode: 'server')
import nuxt_plugin_offersinitserver_59f16a28 from 'nuxt_plugin_offersinitserver_59f16a28' // Source: ../plugins/offers-init.server.ts (mode: 'server')
import nuxt_plugin_globalcomponents_91a8526c from 'nuxt_plugin_globalcomponents_91a8526c' // Source: ../plugins/global-components (mode: 'all')
import nuxt_plugin_jsonld_cea01772 from 'nuxt_plugin_jsonld_cea01772' // Source: ../plugins/json-ld (mode: 'all')
import nuxt_plugin_portal_4532993c from 'nuxt_plugin_portal_4532993c' // Source: ../plugins/portal (mode: 'all')
import nuxt_plugin_componentlibrary_0c1b5196 from 'nuxt_plugin_componentlibrary_0c1b5196' // Source: ../plugins/component-library (mode: 'all')
import nuxt_plugin_trackingfbclient_36c4f320 from 'nuxt_plugin_trackingfbclient_36c4f320' // Source: ../plugins/tracking-fb.client.ts (mode: 'client')
import nuxt_plugin_vuetoucheventsclient_1f1f28a2 from 'nuxt_plugin_vuetoucheventsclient_1f1f28a2' // Source: ../plugins/vue-touch-events.client.js (mode: 'client')
import nuxt_plugin_cartstateclient_4b97862e from 'nuxt_plugin_cartstateclient_4b97862e' // Source: ../plugins/cart-state.client.ts (mode: 'client')
import nuxt_plugin_screensizeclient_006130c0 from 'nuxt_plugin_screensizeclient_006130c0' // Source: ../plugins/screen-size.client.ts (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const store = null
  const router = await createRouter(ssrContext, config, { store })

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[],"link":[],"style":[],"script":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_bb5c32c0 === 'function') {
    await nuxt_plugin_plugin_bb5c32c0(app.context, inject)
  }

  if (typeof nuxt_plugin_middleware_de133f60 === 'function') {
    await nuxt_plugin_middleware_de133f60(app.context, inject)
  }

  if (typeof nuxt_plugin_appplugin_cef3b808 === 'function') {
    await nuxt_plugin_appplugin_cef3b808(app.context, inject)
  }

  if (typeof nuxt_plugin_configplugin_6b82abda === 'function') {
    await nuxt_plugin_configplugin_6b82abda(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_nitrobridgeserver_7ffc0444 === 'function') {
    await nuxt_plugin_nitrobridgeserver_7ffc0444(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nitrobridgeclient_2e8744cc === 'function') {
    await nuxt_plugin_nitrobridgeclient_2e8744cc(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_01c06582 === 'function') {
    await nuxt_plugin_plugin_01c06582(app.context, inject)
  }

  if (typeof nuxt_plugin_image_ffb0029e === 'function') {
    await nuxt_plugin_image_ffb0029e(app.context, inject)
  }

  if (typeof nuxt_plugin_unhead_64b1d903 === 'function') {
    await nuxt_plugin_unhead_64b1d903(app.context, inject)
  }

  if (typeof nuxt_plugin_capiplugin_3a7f51c6 === 'function') {
    await nuxt_plugin_capiplugin_3a7f51c6(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_errorpluginserver_0e3e162c === 'function') {
    await nuxt_plugin_errorpluginserver_0e3e162c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_00loggerclient_2112379c === 'function') {
    await nuxt_plugin_00loggerclient_2112379c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_00loggerserver_f268adb8 === 'function') {
    await nuxt_plugin_00loggerserver_f268adb8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_01sentryclient_4e0d254a === 'function') {
    await nuxt_plugin_01sentryclient_4e0d254a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_02shopbackendclient_0abae047 === 'function') {
    await nuxt_plugin_02shopbackendclient_0abae047(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_03fetchRedirectsserver_579ebf2e === 'function') {
    await nuxt_plugin_03fetchRedirectsserver_579ebf2e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_goliathclient_cffddb24 === 'function') {
    await nuxt_plugin_goliathclient_cffddb24(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_goliathserver_048af814 === 'function') {
    await nuxt_plugin_goliathserver_048af814(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_storeinitserver_12d7c08e === 'function') {
    await nuxt_plugin_storeinitserver_12d7c08e(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_offersinitserver_59f16a28 === 'function') {
    await nuxt_plugin_offersinitserver_59f16a28(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_91a8526c === 'function') {
    await nuxt_plugin_globalcomponents_91a8526c(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_cea01772 === 'function') {
    await nuxt_plugin_jsonld_cea01772(app.context, inject)
  }

  if (typeof nuxt_plugin_portal_4532993c === 'function') {
    await nuxt_plugin_portal_4532993c(app.context, inject)
  }

  if (typeof nuxt_plugin_componentlibrary_0c1b5196 === 'function') {
    await nuxt_plugin_componentlibrary_0c1b5196(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_trackingfbclient_36c4f320 === 'function') {
    await nuxt_plugin_trackingfbclient_36c4f320(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetoucheventsclient_1f1f28a2 === 'function') {
    await nuxt_plugin_vuetoucheventsclient_1f1f28a2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cartstateclient_4b97862e === 'function') {
    await nuxt_plugin_cartstateclient_4b97862e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_screensizeclient_006130c0 === 'function') {
    await nuxt_plugin_screensizeclient_006130c0(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
